import { postOrder, postPaypalCapture, postPaypalOrder, postPaypalSubscription, putPaypalSubscription } from './checkout';
import { createScripts } from './util';

class PaypalError extends Error {
  constructor(private _search: Record<string, string>) {
    super('Paypal Error');
  }
  get search() {
    return this._search;
  }
}

export default class Paypal {
  private _paypal: PaypalInstance | null = null;
  private _order: CheckoutOrderData = {} as CheckoutOrderData;
  private _product: CheckoutProductData = {} as CheckoutProductData;
  private _promotionData: CheckoutPromotionCodeData = {} as CheckoutPromotionCodeData;
  private _scripts: string[] = [];
  private _events: Record<string, (params?: any) => void> = {};
  constructor() {
    console.log('creat paypal');
  }

  async init(
    product: CheckoutProductData,
    events: Record<string, (params?: any) => void>,
    // onComplete: (search: Record<string, string | number>) => void,
    // onFail: (search: Record<string, string | number>) => void,
  ): Promise<void> {
    this.setProduct(product);
    this._events = events;
    this._scripts = [
      `https://www.paypal.com/sdk/js?client-id=${process.env.REACT_APP_PAYPAL_CLIENT_ID}&components=buttons&disable-funding=card${
        product.subscription ? '&vault=true&intent=subscription' : ''
      }`,
    ];
    await createScripts(this._scripts);
    this._paypal = (window as any).paypal as PaypalInstance;

    this._paypal
      .Buttons({
        onInit: () => {
          return;
        },
        // env: process.env.REACT_APP_PAYPAL_ENV || 'sandbox',
        style: {
          height: 55,
          color: 'black',
        },
        ...(product.subscription ? this._onSubscription() : this._onCheckout()),
        onError: (e) => {
          this._events.onError && this._events.onError(e);
        },
      })
      .render('#paypal-button');
  }

  destroy(): void {
    if (!this._paypal) {
      return;
    }

    this._scripts.map((src) => {
      document.querySelector(`script[src="${src}"]`)?.remove();
    });
    this._scripts = [];
    this._paypal = null;
    this._promotionData = {} as CheckoutPromotionCodeData;
    this._product = {} as CheckoutProductData;
    this._order = {} as CheckoutOrderData;
    this._events = {};
  }

  _onCheckout(): Record<string, any> {
    return {
      createOrder: this._createOrder.bind(this),
      onApprove: this._onCheckoutApprove.bind(this),
    };
  }

  _onSubscription(): Record<string, any> {
    return {
      createSubscription: this._createSubscription.bind(this),
      onApprove: this._onSubscriptionApprove.bind(this),
    };
  }

  async _createSubscription(): Promise<string> {
    try {
      await this.getOrder();
      let subscription;
      if (this._product && this._product.planId) {
        subscription = await postPaypalSubscription({
          orderId: this._order.id,
          planId: this._product.planId,
        });
      }
      return subscription.id;
    } catch (e) {
      console.error('[_createSubscription]', e);
      throw new PaypalError({
        orderId: this._order.id,
        productId: this._product.id,
        imp_success: 'false',
        error_msg: e.message,
      } as any).search;
    }
  }

  async _onSubscriptionApprove(data: PaypalCaptureBody): Promise<void> {
    try {
      this._events && this._events.onLoadingStart && this._events.onLoadingStart();
      if (data.subscriptionID) {
        const capturedOrder = await putPaypalSubscription({
          orderId: this._order.id,
          subscriptionId: data.subscriptionID,
        });
        console.log(capturedOrder);
        this._events &&
          this._events.onComplete &&
          this._events.onComplete({
            orderId: this._order.id,
            productId: this._product.id,
            imp_success: 'true',
          });
      } else {
        throw new PaypalError({
          orderId: this._order.id,
          productId: this._product.id,
          imp_success: 'false',
        } as any).search;
      }
    } catch (e) {
      console.error('[_onSubscriptionApprove]', e);
      throw new PaypalError({
        orderId: this._order.id,
        productId: this._product.id,
        imp_success: 'false',
        error_msg: e.message,
      } as any).search;
    }
  }

  async _createOrder(): Promise<string | boolean> {
    try {
      await this.getOrder();
      const paypalOrder = await postPaypalOrder({
        orderId: this._order.id,
      });
      console.log('paypalOrder', paypalOrder);
      return paypalOrder.id;
    } catch (e) {
      console.error('[_createOrder]', e);
      throw new PaypalError({
        orderId: this._order.id,
        productId: this._product.id,
        imp_success: 'false',
        error_msg: e.message,
      } as any).search;
    }
  }

  async _onCheckoutApprove(data: PaypalCaptureBody): Promise<void> {
    try {
      this._events && this._events.onLoadingStart && this._events.onLoadingStart();
      const capturedOrder = await postPaypalCapture(data);
      console.log(capturedOrder, this._order.id);
      this._events &&
        this._events.onComplete &&
        this._events.onComplete({
          orderId: this._order.id,
          productId: this._product.id,
          imp_success: 'true',
        });
    } catch (e) {
      console.error('[_onCheckoutApprove]', e);
      throw new PaypalError({
        orderId: this._order.id,
        productId: this._product.id,
        imp_success: 'false',
        error_msg: e.message,
      } as any).search;
    }
  }

  async getOrder(): Promise<void> {
    try {
      const order = await postOrder({
        productId: this._product.id,
        ...(this._promotionData && this._promotionData.id
          ? {
              promotionId: this._promotionData.id,
            }
          : {}),
      });
      this.setOrder(order.order);
    } catch (e) {
      throw e;
    }
  }

  setOrder(order: CheckoutOrderData): void {
    this._order = order;
  }

  setProduct(product: CheckoutProductData): void {
    this._product = product;
  }

  // setEnable(): void {
  //   if (this._actions && this._actions.enable) {
  //     this._actions.enable();
  //   }
  // }

  // setDisable(): void {
  //   if (this._actions && this._actions.disable) {
  //     this._actions.disable();
  //   }
  // }

  setPromotionCode(promotionData: CheckoutPromotionCodeData): void {
    this._promotionData = promotionData;
  }
}
